import { isKeyValueTrue } from "cando-util";

const hasRule = (question, key) => {
	const value = question?.[key]?.value ?? question?.[key];
	return value !== undefined && value !== null && value !== "";
};

export const isFormFieldHidden = (question, formData) => {
	if (hasRule(question, "hideInForm")) {
		return isKeyValueTrue(question, formData, "hideInForm");
	}
	if (hasRule(question, "showInForm")) {
		return !isKeyValueTrue(question, formData, "showInForm");
	}
	return false;
};
